module.exports = "/_next/static/images/testimonial-thumb-5-05b23944da57f99b3c057eb3af75d919.jpg";